import { css } from '@emotion/react';

import { getTheme } from 'src/utils/getTheme';

const { theme, isHosTheme } = getTheme();

export const styles = {
    container: css({
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '8px',
        padding: '6px 12px',
        color: theme.palette.common.white,
        background: theme.palette.success.main,
        border: `1px solid ${theme.palette.grey[600]}`,
        ...(isHosTheme && { borderRadius: theme.custom.borderRadius[23], marginBottom: '10px' }),
    }),
};
